import React, {Component} from 'react';

import {Route, Switch, NavLink} from 'react-router-dom';

import {Home, Demo1, Demo2, Demo3, Demo4} from './routes';

class App extends Component {
  render() {
    return (
      <div className="App">
        <nav>
          <NavLink to="/demo/one">Simple 2D</NavLink>
          <NavLink to="/demo/two">Simple 3D</NavLink>
          <NavLink to="/demo/three">Complex 3D</NavLink>
          <a href="https://storage.googleapis.com/tfjs-models/demos/posenet/camera.html" target="_blank">PoseNet's own Example</a>
        </nav>
        <small>Press any key to toggle the webcam stream.</small>
        <main>
          <Switch>
            <Route exact path="/" component={Home}/>
            <Route path="/demo/one" component={Demo3}/>
            <Route path="/demo/two" component={Demo2}/>
            <Route path="/demo/three" component={Demo1}/>
            <Route component={Home}/>
          </Switch>
        </main>
      </div>
    );
  }
}

export default App;
